/**
 * Request Meta Section Component
 *
 * @module @features/requests/components/RequestDetails/components/RequestMeta
 */

import React from 'react';
import { useI18n } from '@shared/i18n';
import { formatDate } from '@features/requests/utils';
import type { Request } from '@features/requests/types';
import styles from '../RequestDetails.module.css';

/**
 * Props for RequestMeta component
 */
export interface RequestMetaProps {
    request: Request;
}

/**
 * Displays request metadata (created date, updated date)
 */
export function RequestMeta({ request }: RequestMetaProps): React.ReactElement {
    const { t } = useI18n();

    const createdDate = formatDate(request.createdAt);
    const updatedDate = formatDate(request.updatedAt);

    return (
        <div className={styles.meta}>
            <div className={styles.metaItem}>
                <span className={styles.metaLabel}>
                    {t('requests.details.created')}:{' '}
                </span>
                <span className={styles.metaValue}>{createdDate}</span>
            </div>
            <div className={styles.metaItem}>
                <span className={styles.metaLabel}>
                    {t('requests.details.lastUpdated')}:{' '}
                </span>
                <span className={styles.metaValue}>{updatedDate}</span>
            </div>
        </div>
    );
}
